import React from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../contexts/AuthContext";

/**
 * Read-only notice shown above mutation forms when the current user is the
 * investor demo `viewer` role.
 *
 * `action` accepts either a translation key suffix (e.g. "buy", "retire",
 * "deposit", "kyc") which is resolved against `t("demo.lock_action_*")`,
 * or a literal string fallback for ad-hoc usage.
 */
export function DemoLockNotice({ action = "this action" }) {
  const { isViewer } = useAuth();
  const { t } = useTranslation();
  if (!isViewer) return null;
  const knownKeys = { buy: "lock_action_buy", retire: "lock_action_retire", deposit: "lock_action_deposit", kyc: "lock_action_kyc" };
  const labelKey = knownKeys[action];
  const label = labelKey ? t(`demo.${labelKey}`) : action;
  return (
    <div
      data-testid="demo-lock-notice"
      className="border border-ink bg-ink text-bg p-4 text-xs font-mono uppercase tracking-[0.18em] flex items-center gap-3"
    >
      <span className="inline-block w-1.5 h-1.5 rounded-full bg-leaf animate-pulse"></span>
      <span className="text-leaf">{t("demo.eyebrow")}</span>
      <span className="normal-case tracking-normal font-sans text-xs text-bg/80">
        {label} {t("demo.lock_note")}
      </span>
    </div>
  );
}

/** Convenience: wraps children in a div that's visually frozen when viewer is true. */
export function DemoLockWrap({ children, className = "" }) {
  const { isViewer } = useAuth();
  return (
    <div className={`${className} ${isViewer ? "pointer-events-none opacity-40 select-none" : ""}`}>
      {children}
    </div>
  );
}
